import { render } from "./privateNumber.vue?vue&type=template&id=2301a429&scoped=true"
import script from "./privateNumber.vue?vue&type=script&lang=js"
export * from "./privateNumber.vue?vue&type=script&lang=js"

import "./privateNumber.vue?vue&type=style&index=0&id=2301a429&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2301a429"

export default script